import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/home/Home";
import Footer from "./components/footer/Footer";
import About from "./components/about/About";
import AboutPresidents from "./components/about/AboutPresidents";
import Privacy from "./components/information/Privacy";
import Terms from "./components/information/Terms";
import RefundPolicy from "./components/information/RefundPolicy";
import ShippingPolicy from "./components/information/ShippingPolicy";
import Blog from "./components/blogs/Blog";
import Blog1 from "./components/blogs/Blog1";
import Blog2 from "./components/blogs/Blog2";

import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import CWC from "./components/about/CWC";
import Contact from "./components/contact/Contact";
import ScrollToTop from "./components/ScrollToTop";
import Event1 from "./components/home/event/Event1";
import Event2 from "./components/home/event/Event2";
import Event3 from "./components/home/event/Event3";
import NotFound from "./components/NotFound";
import Event4 from "./components/home/event/Event4";
import Event5 from './components/home/event/Event5';
import Event6 from './components/home/event/Event6';
import Event7 from './components/home/event/Event7';
import Event8 from './components/home/event/Event8';
import Event9 from './components/home/event/Event9';
import Event10 from './components/home/event/Event10';
import Event11 from './components/home/event/Event11';
import Event12 from './components/home/event/Event12';
import Event13 from './components/home/event/Event13';
import Event14 from './components/home/event/Event14';
import Event15 from './components/home/event/Event15';
import Event16 from './components/home/event/Event16';
import Event17 from './components/home/event/Event17';
import Event18 from './components/home/event/Event18';
import Event19 from './components/home/event/Event19';
import Event20 from './components/home/event/Event20';
import Event21 from "./components/home/event/Event21";
import Event22 from "./components/home/event/event22";
import Event23 from "./components/home/event/event23";

  
function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/event-1" element={<Event1 />} />
          <Route exact path="/event-2" element={<Event2 />} />
          <Route exact path="/event-3" element={<Event3 />} />
          <Route exact path="/event-4" element={<Event4 />} /> 
          <Route exact path="/event-5" element={<Event5 />} />
          <Route exact path="/event-6" element={<Event6 />} />
          <Route exact path="/event-7" element={<Event7 />} />
          <Route exact path="/event-8" element={<Event8 />} />
          <Route exact path="/event-9" element={<Event9 />} />
          <Route exact path="/event-10" element={<Event10 />} />
          <Route exact path="/event-11" element={<Event11 />} />
          <Route exact path="/event-12" element={<Event12 />} />
          <Route exact path="/event-13" element={<Event13 />} />
          <Route exact path="/event-14" element={<Event14 />} />
          <Route exact path="/event-15" element={<Event15 />} />
          <Route exact path="/event-16" element={<Event16 />} />
          <Route exact path="/event-17" element={<Event17 />} />
          <Route exact path="/event-18" element={<Event18 />} />
          <Route exact path="/event-19" element={<Event19 />} />
          <Route exact path="/event-20" element={<Event20 />} />
          <Route exact path="/event-21" element={<Event21 />} />
          <Route exact path="/event-22" element={<Event22 />} />
          <Route exact path="/event-23" element={<Event23 />} />
          
          <Route exact path="/about" element={<About />} />
          <Route exact path="/about-presidents" element={<AboutPresidents />} />
          <Route exact path="/about-cwc" element={<CWC />} />
          <Route exact path="/contact" element={<Contact />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/blog/The-Future-of-HVAC-Industry-in-India" element={<Blog1 />} />
          <Route exact path="/blog/Radiant-Cooling-The-Future-of-Energy-Efficient" element={<Blog2 />} />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          {/* 404 */}
          <Route exact path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
